module.exports = __webpack_public_path__ + "static/img/TaskAdd_fail.52cf75d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TaskAdd_fail.jpg
// module id = X0HG
// module chunks = 1